// @ts-ignore
import cookie from 'react-cookies';

export const Key = {
  ATK: 'ACCESS-TOKEN', // 访问令牌在cookie的key值
  RTK: 'REFRESH-TOKEN', // 刷新令牌在cookie的key值
  UIK: 'USER-INFO', // 用户信息key
};

const expires = new Date();
// 一天
expires.setDate(Date.now() + 1000 * 60 * 60 * 24);

export const checkKey = (key: string) => {
  if (!key) {
    throw new Error('Not find key.');
  }
  if (typeof key === 'object') {
    throw new Error("key can't is a object");
  }
};

// 获取cookie
export const getCookie = (key: string) => {
  checkKey(key);
  return cookie.load(key);
};

// 添加cookie
export const setCookie = (key: string, value: string) => {
  checkKey(key);
  cookie.save(key, value, {
    path: '/',
    expires,
    // domain: '.aicc.com',
  });
};

// 删除cookie
export const removeCookie = (key: string) => {
  checkKey(key);
  cookie.remove(key, {
    path: '/',
    // domain: '.aicc.com'
  });
};
